<template>
  <svg class="svg" width="82" height="196" viewBox="0 0 82 196" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M-23 8L67 98L-23 188" stroke="url(#paint0_linear_red)" stroke-width="20"/>
    <defs>
      <linearGradient id="paint0_linear_red" x1="67" y1="98" x2="-23" y2="98" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF1C0C"/>
        <stop offset="1" stop-color="#770000"/>
        <stop offset="1" stop-color="#770000"/>
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  name: "RightArrowRed",
}
</script>
<style lang="scss" scoped>
.svg{
  width: 90px;
  height: 180px;
}

</style>